<template>
  <v-container>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-row class="mt-10">
      <v-col>
        <ServiceExpandable :state="state"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ServiceExpandable from "../../components/expandables/ServiceExpandable";
import { mapState } from 'vuex';
import {BreadcrumbUtil} from "@/util/BreadcrumbUtil";
export default {
  created() {
    this.items = BreadcrumbUtil.setServiceItem(
        this.items,
        this.branchId,
        this.branchName,
        this.allBranches,
        this.lang
    )
  },
  props: ['state'],
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId : state => state.Branch.branch_id,
      lang : state=> state.Branch.lang,
      services : state=> state.ServiceMenu.service_menu
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items = BreadcrumbUtil.setServiceItem(
          this.items,
          this.branchId,
          this.branchName,
          this.allBranches,
          this.lang
      )
    }
  },
  methods:{

  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        to: "/home/:branch"
      },
      {
        text: "SERVICE",
        to: "/:branch/service"
      }
    ]
  }),
  components: {
    ServiceExpandable
  }
};
</script>

<style></style>
